import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_AUDIO_URL](state, p) {
    const drp = p.drp;
    drp.audioFile = p.audioFile;
  },
};

const actions = {
  setAudioFile: ({ commit }, payload) => {
    commit(types.SET_AUDIO_URL, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-player/vuex.js